import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c4ce707&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/__socialLogin.scss?vue&type=style&index=0&id=6c4ce707&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4ce707",
  null
  
)

export default component.exports